/* eslint-disable react-hooks/exhaustive-deps */

import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';

import {
  getAuthClientPolicies,
  getAuthDateSummary,
  getAuthorizationComments,
  getAuthorizationSummary,
  getCommunicationInfo,
  getDepartureAddress,
  getDestinationAddress,
  getEmployeeInfo,
  getFamilyMembers,
  getFamilyPets,
  getFinanceAndTax,
  getServices,
  getTeam,
  getUserSettings,
  setAuthId
} from '../../store/actions/authorizations.actions';
import { getClientDetails, setClientId, setLoadingComplete } from 'modules/clients/clients.actions';
import { showToast } from 'modules/layout/layout.actions';
import CommentsAndNotesComponent from './commentsAndNotes.component';
import { fetchAuthDetails, fetchCommentsAndNotes, fetchEnumerations } from 'modules/authorizations/utils/fetchDataDetailsService';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { getInternalUsers } from 'modules/common/common.actions';
import { getExpenseCodesByClientId } from 'modules/authorizations/store/actions/dataManagement.actions';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';

const CommentsAndNotesView = props => {
  const { authorizationDetails, currentAuthId, serviceOptionId, viewMode, id, match } = props;
  const location = useLocation();
  const details = authorizationDetails ? authorizationDetails[currentAuthId] : null;
  const [isLoading, setIsLoading] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const queryStringServiceOptionId = queryParams.get('regardingId');
  const queryCommentId = queryParams.get('commentId');
  const commentIdInt = queryCommentId ? parseInt(queryCommentId, 10) : null;

  let authId = id ? id : match?.params?.id;

  useEffect(() => {
    const fetchData = async () => {
      props.setAuthId(authId);
      setIsLoading(true);

      //TODO - Fetching details cause parent modules (Homesale) to blow up due to forcing a screen refresh which causes this component to unmount while loading..
      //We need the business to stop wanting all these short cuts for MVP.......
      if (!details) {
        await fetchAuthDetails(details, authId, props);
      }
      await fetchCommentsAndNotes(details, authId, props);
      await fetchEnumerations(props);
      const clientRecordId =
        details?.authorizationDetails?.clientId || (await props.getAuthorizationSummary(authId))?.response?.authorizationDetails?.clientId;
      let expenseCodeClientId = null;
      if (clientRecordId) {
        props.setClientId(clientRecordId);
        const clientResp = await props.getClientDetails(clientRecordId);
        expenseCodeClientId = clientResp?.response?.clientDetails?.clientId || clientResp?.response?.clientId || null;
      }

      if (expenseCodeClientId) {
        await props.getExpenseCodesByClientId(expenseCodeClientId);
      }
      await props.getInternalUsers();
      props.setLoadingComplete();
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const canReadComments = hasPermission(Permissions.File.Comments.Read);
  const canEditComments = hasPermission(Permissions.File.Comments.Edit);
  const canReadExceptions = hasPermission(Permissions.File.Exceptions.Read);
  const canEditExceptions = hasPermission(Permissions.File.Exceptions.Edit);

  if (!canReadComments) {
    props.history.push('/');
    return null;
  }

  return (
    <>
      {!isLoading && details && (
        <CommentsAndNotesComponent
          details={details}
          authorizationId={authId}
          history={props.history}
          serviceOptionId={serviceOptionId}
          filterString={queryStringServiceOptionId}
          viewMode={viewMode}
          enumerations={props.enumerations}
          initialCommentId={commentIdInt}
          clientInfo={props.clientsInfo[details.authorizationDetails.clientId]}
          internalUsers={props.internalUsers}
          internalUserTypesEnum={props.internalUserTypesEnum}
          expenseCodes={props.expenseCodes || []}
          isReadOnly={!canEditComments}
          canReadExceptions={canReadExceptions}
          canEditExceptions={canEditExceptions}
          registerLeaveGuard={props.registerLeaveGuard}
        />
      )}
      {isLoading && <FullscreenSpinner />}
    </>
  );
};

CommentsAndNotesView.propTypes = {
  authorizationDetails: PropTypes.object,
  currentAuthId: PropTypes.string,
  match: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { authorizationDetails, isLoading, currentAuthId, expenseCodes } = state.authorizations;
  const { clientsInfo } = state.clients;
  const { internalUsers } = state.common;
  const enumerations = state.enumerations;
  const internalUserTypesEnum = enumerations?.allEnums?.internalUserTypes || [];

  return {
    authorizationDetails,
    isLoading,
    currentAuthId,
    enumerations,
    clientsInfo,
    internalUsers,
    internalUserTypesEnum,
    expenseCodes
  };
};

export default compose(
  connect(mapStateToProps, {
    setAuthId,
    setLoadingComplete,
    showToast,
    getAuthorizationSummary,
    getEmployeeInfo,
    getAuthDateSummary,
    getCommunicationInfo,
    getDepartureAddress,
    getDestinationAddress,
    getAuthClientPolicies,
    getTeam,
    getServices,
    getUserSettings,
    getFamilyPets,
    getFamilyMembers,
    getFinanceAndTax,
    getAuthorizationComments,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getClientDetails,
    setClientId,
    getInternalUsers,
    getExpenseCodesByClientId
  })
)(CommentsAndNotesView);
